import EditDashboardContainer from './container';

const EditDashboard = EditDashboardContainer;

export default EditDashboard;
